// Textes partagés : barre de navigation, pied de page, sélecteur de langue.
// RÈGLE : les valeurs françaises sont le texte EXACT du site d'avant la
// traduction — on ne réécrit pas la copie en passant.
export default {
  'nav.home': 'Accueil',
  'nav.shop': 'Boutique',
  'nav.rules': 'Règles du jeu',
  'nav.about': 'À Propos',
  'nav.contact': 'Contact',
  'nav.cart': 'Mon Panier',
  'nav.admin': 'Administration',
  'nav.adminShort': 'Admin',
  'nav.adminTitle': 'Accès Admin',
  'nav.order': 'Commander',
  'nav.cartEmpty': 'Votre panier est vide',
  'nav.checkout': 'Procéder au paiement',
  'nav.login': 'Se connecter',
  'nav.loginShort': 'Connexion',
  'nav.logout': 'Déconnexion',
  'nav.orders': 'Commandes',
  'nav.myOrders': 'Mes Commandes',
  'nav.profile': 'Profil',
  'nav.myProfile': 'Mon Profil',
  'nav.language': 'Langue',

  'footer.tagline':
    'Créons des moments magiques en famille! Nos puzzles transforment la révélation du sexe de bébé en une aventure inoubliable.',
  'footer.badge.interactive': '🎲 Interactif',
  'footer.badge.festive': '🎊 Festif',
  'footer.badge.family': '💝 Famille',
  'footer.nav': 'Navigation',
  'footer.legal': 'Légal',
  'footer.privacy': 'Confidentialité',
  'footer.terms': 'Conditions Générales',
  'footer.paymentSecurity': 'Sécurité Paiement',
  'footer.legalNotice': 'Mentions Légales',
  'footer.connected': 'Reste Connecté',
  'footer.newsletter': 'Recois les dernières infos:',
  'footer.newsletterPlaceholder': 'ton@email.com',
  'footer.madeWith': 'Créé avec',
  'footer.madeFor': 'pour les familles magiques.',
  "footer.maFacture": "Retrouver ma facture",
};
